/* eslint-disable max-len */
import {
  REQUEST_RESOURCE, GENERATE_RESUME, VIEW_FILE, RESOURCE_VIEW_SUGGESSTION,
  UPLOAD_RESUME,
  UPDATE_RESUME,
  CONVERT_RESUME,
} from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';

export const getRequestResourceData = (id, filters = {}) => {
  // API call to fetch resource requirement data
  let url = `${REQUEST_RESOURCE}/?staffingId=${id}`;

  // Add employee name filter
  if (filters.employeeName) {
    url += `&employee_name=${encodeURIComponent(filters.employeeName)}`;
  }

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const updateRequestResourceData = (data) => {
  // API call to update resource requirement data
  return {
    url: REQUEST_RESOURCE,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const deleteStaffRequirement = (id) => {
  // API call to delete staff augmentation
  return {
    url: `${REQUEST_RESOURCE}/${id}`,
    method: 'delete',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const generateResume = (data) => {
  return {
    url: GENERATE_RESUME,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};


export const getViewFileData = (employeeId, staffingId, isJDviewed, isResumeView, resumeTrackerId) => {
  let url = `${VIEW_FILE}?staffingId=${staffingId}&isJDviewed=${isJDviewed}`;

  if (!isJDviewed) {
    const baseParams = `staffingId=${staffingId}&isJDviewed=false&isResumeView=${isResumeView}`;

    if (employeeId && employeeId !== 'N/A') {
      url = `${VIEW_FILE}?employeeId=${employeeId}&${baseParams}`;
    } else if (resumeTrackerId) {
      url = `${VIEW_FILE}?resumeTrackerId=${resumeTrackerId}&${baseParams}`;
    }
  }

  return {
    url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};


export const getResourceViewSuggestion = (id) => {
  // API call to fetch resource view suggestions
  return {
    url: `${RESOURCE_VIEW_SUGGESSTION}/?staffingId=${id}`,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const UploadResumeApi = (formData) => {
  // API call to upload resume

  return {
    url: UPLOAD_RESUME,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    authRequired: true,
    csrfToken: true,
    payload: formData,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const updateResume = (data) => {
  return {
    url: UPDATE_RESUME,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const convertResume = (data) => {
  return {
    url: CONVERT_RESUME,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};
